import { vkPriceListId } from 'init/vk-price-list-id'
import { vkRetargeting } from 'init/vk-retargeting'
import { convertByRate } from './currency-converter'
import isFunction from 'lodash/isFunction'

const CURRENCY_CODE = 'RUR'

/**
 * Отправка Vk события
 * @param {string} eventType
 * @param {Object} params
 */
export const pushVkEvent = (eventType, params) => {
  if (vkRetargeting && isFunction(vkRetargeting.ProductEvent)) {
    vkRetargeting.ProductEvent(vkPriceListId, eventType, prepareParams(params))
  }
}

/**
 * Подготовка параметров для отправки
 * @param {Object} params - обьект с параметрами
 * @returns {Object}
 */
export const prepareParams = params => {
  if (Array.isArray(params.products)) {
    params.currency_code = CURRENCY_CODE
    const rate = params.currency ? params.currency.rate : 1
    params.products.forEach(productParams => {
      if (productParams.price) {
        if (productParams.price_old && productParams.price < productParams.price_old) {
          productParams.price_old = convertByRate(productParams.price_old, rate)
        } else {
          delete productParams.price_old
        }
        productParams.price = convertByRate(productParams.price, rate)
      }
    })
    delete params.currency
  }
  return params
}
